module.exports = __webpack_public_path__ + "static/media/2.2fe5ba1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Teafloor/2.jpg
// module id = 361
// module chunks = 0